import React from 'react';

import { CliveAvatar } from '~/components/Clive/CliveAvatar';
import { Heading, Text } from '~/components/core/TextComponents';

export const SearchEmptyState: React.FC = () => (
  <div className="flex flex-1 flex-col items-center justify-center">
    <div className="flex flex-col items-center text-center">
      <CliveAvatar mood={CliveAvatar.MOOD.SAD} className="mb-16" size={100} />
      <Heading variant={Heading.TYPES.H2} className="mb-8">
        No results found
      </Heading>
      <Text variant={Text.VARIANTS.SM} colorVariant={Text.COLOR_VARIANTS.SECONDARY}>
        Try adjusting your search or checking for a different keyword.
      </Text>
    </div>
  </div>
);
